export default "__VITE_ASSET__CxlUMYTS__"